import { PropsWithChildren } from 'react';

export default function PreferencesTable({ children }: PropsWithChildren): React.ReactElement {
  return (
    <table className="font-aribau antialiased text-sm w-full">
      <tbody>{children}</tbody>
    </table>
  );
}
